export default class {
  constructor() {
    this.$modal = $(".js-country-modal");
    this.$open = $(".country-box .js-modal-open");
  }

  init() {
    this.$open.click((e) => {
      e.preventDefault();
      const modalData = $(e.target).parents(".country-box").data("modal");
      this.setModalData(modalData);
      this.$modal.modal("show");
    });
  }

  setModalData(data) {
    const content = this.$modal.find(".modal-content");
    content.find(".data").addClass("hidden");

    Object.keys(data).forEach((key) => {
      if (key === "social_media") {
        this.setSocialMedia(data[key]);
        return;
      }

      if (data[key].length) {
        content.find(`.js-${key.toLowerCase()}`).removeClass("hidden");

        if (key === "flag") {
          content.find(".js-flag").css("backgroundImage", `url(${data[key]})`);
          return;
        }

        if (key === "position") {
          content.find(".js-director .label").text(data[key]);
          return;
        }

        if (key === "website") {
          content.find(".js-val").attr("href", data[key]);
          return;
        }

        content.find(`.js-${key.toLowerCase()} .js-val`).text(data[key]);
      }
    });
  }

  setSocialMedia(socialData) {
    const socialMedia = this.$modal.find(".content .social-media");
    socialMedia.find("li").addClass("hidden");
    $(".js-social").removeClass("hidden");
    socialMedia.find("li a").attr("href", "#");
    let hideSocialMedia = true;
    Object.keys(socialData).forEach((key) => {
      if (socialData[key].length) {
        hideSocialMedia = false;
        socialMedia
          .find(`.js-${key.toLowerCase()}`)
          .removeClass("hidden")
          .find("a")
          .attr("href", socialData[key]);
      }
    });
    if (hideSocialMedia) {
      $(".js-social").addClass("hidden");
    }
  }
}
